webpackJsonp([263791100135453],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contributorsJson = __webpack_require__(431);
	
	var About = function About() {
	  var renderContributors = function renderContributors(contributors) {
	    if (contributors.length > 0) {
	      return contributors.map(function (contributor) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'column is-one-quarter', key: contributor.login },
	          _react2.default.createElement(
	            'div',
	            { className: 'contributor' },
	            _react2.default.createElement(
	              'a',
	              { href: contributor.html_url, target: '_blank' },
	              _react2.default.createElement('img', { alt: contributor.name, src: contributor.avatar_url }),
	              _react2.default.createElement(
	                'h4',
	                { className: 'no-permalink' },
	                contributor.name
	              )
	            )
	          )
	        );
	      });
	    }
	    return [];
	  };
	
	  var renderedContributors = renderContributors(contributorsJson);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns is-multiline contributors' },
	    renderedContributors
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

	module.exports = [{"id":20046,"login":"fahad19","html_url":"https://github.com/fahad19","contributions":388,"name":"Fahad Ibnay Heylaal","avatar_url":"https://avatars2.githubusercontent.com/u/20046?v=4"},{"id":1031418,"login":"alexmiranda","html_url":"https://github.com/alexmiranda","contributions":28,"name":"Alex Miranda","avatar_url":"https://avatars3.githubusercontent.com/u/1031418?v=4"},{"id":1002056,"login":"mAiNiNfEcTiOn","html_url":"https://github.com/mAiNiNfEcTiOn","contributions":19,"name":"Ricardo Machado","avatar_url":"https://avatars1.githubusercontent.com/u/1002056?v=4"},{"id":5746186,"login":"viacheslaff","html_url":"https://github.com/viacheslaff","contributions":16,"name":"Viacheslav Zhuravski","avatar_url":"https://avatars2.githubusercontent.com/u/5746186?v=4"},{"id":2970736,"login":"discosultan","html_url":"https://github.com/discosultan","contributions":8,"name":"Jaanus Varus","avatar_url":"https://avatars1.githubusercontent.com/u/2970736?v=4"},{"id":1122274,"login":"markvincze","html_url":"https://github.com/markvincze","contributions":8,"name":"Mark Vincze","avatar_url":"https://avatars3.githubusercontent.com/u/1122274?v=4"},{"id":367236,"login":"jackTheRipper","html_url":"https://github.com/jackTheRipper","contributions":6,"name":"Jean Baudin","avatar_url":"https://avatars0.githubusercontent.com/u/367236?v=4"},{"id":21044625,"login":"gtzio","html_url":"https://github.com/gtzio","contributions":4,"name":"Georgia Tziola","avatar_url":"https://avatars0.githubusercontent.com/u/21044625?v=4"},{"id":3122478,"login":"AlexDudar","html_url":"https://github.com/AlexDudar","contributions":2,"name":"Alexandr Dudar","avatar_url":"https://avatars1.githubusercontent.com/u/3122478?v=4"},{"id":778908,"login":"asci","html_url":"https://github.com/asci","contributions":1,"name":"Artem Riasnianskyi","avatar_url":"https://avatars0.githubusercontent.com/u/778908?v=4"},{"id":5271777,"login":"nunorfpt","html_url":"https://github.com/nunorfpt","contributions":1,"name":"nunorfpt","avatar_url":"https://avatars1.githubusercontent.com/u/5271777?v=4"},{"id":145040,"login":"spzm","html_url":"https://github.com/spzm","contributions":1,"name":"Uladzimir Dziomin","avatar_url":"https://avatars3.githubusercontent.com/u/145040?v=4"}]

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-36d2ffae29c27a2a87fa.js